import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
//import { DataGrid } from '@material-ui/data-grid'
import {
    GridRowsProp,
    GridRowModesModel,
    GridRowModes,
    DataGrid,
    GridColDef,
    GridToolbarContainer,
    GridActionsCellItem,
    GridEventListener,
    GridRowId,
    GridRowModel,
    GridRowEditStopReasons,
  } from '@mui/x-data-grid'
import DeleteIcon from '@mui/icons-material/Delete';

import Typography from '@mui/material/Typography';
import { TextField } from '@material-ui/core';
import { Button, Checkbox, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';
import {v4 as uuid} from "uuid"; 
import { Backdrop, CircularProgress } from '@mui/material';
import {  InputLabel,  MenuItem,  Select } from '@material-ui/core';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
//import { Field, reduxForm } from 'redux-form'
import axios from 'axios';
import ModalNutricionsPlan from './ModalNutricionsPlan';
const url = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/history/create";


export default function UpdateHistoryNutriocionista(props) {
   
  
     // const [body, setBody] = useState({ valoration: '', objective: '', activity: '', therapy: '', conclusion:'' })
     const [body, setBody] = useState(props.affiliateInfo.evolutionsNutricionist[props.indexEvolution]);
     const handleChange = e => {
        console.log("e.target.name " + e.target.name);
        console.log("e.target.value " + e.target.value);
        
		setBody({
			...body,
			[e.target.name]: e.target.value
		})
        console.log("en cambios ^^= " + JSON.stringify(body));
      
    }
    const processRowUpdate = React.useCallback(
        async(newRow) => {
          const response = await React.dispatch();
          console.log("newRow " + newRow);
          return response; // return the new row containing the row id
        }, [],
      );

    const handleChangeListado = e => {
      //  console.log("e.target.name " + e.target.name);
     //   console.log("e.target.value " + e.target.value);
        body.frequencyFoodConsumption[e.target.name] = e.target.value
		setBody(body)
    //    console.log("en cambios ^^= " + JSON.stringify(body));
      
    }

    const [bodyNutricionistPlan, setBodyNutricionistPlan] = useState({ id: '', description: ''})
    const handleChangeNutricionistPlan = e => {
        setBodyNutricionistPlan({
          ...bodyNutricionistPlan,
          [e.target.name]: e.target.value
      })
    }

    const [bodyFoodCanEat, setBodyFoodCanEat] = useState({ id: '', description: ''})
    const handleChangeFoodCanEat = e => {
        setBodyFoodCanEat({
          ...bodyFoodCanEat,
          [e.target.name]: e.target.value
      })
    }

    const [bodyFoodNotAllowedEat, setBodyFoodNotAllowedEat] = useState({ id: '', description: ''})
    const handleChangeFoodNotAllowedEat = e => {
        setBodyFoodNotAllowedEat({
          ...bodyFoodNotAllowedEat,
          [e.target.name]: e.target.value
      })
    }

    const [bodyFruitCanEat, setBodyFruitCanEat] = useState({ id: '', description: ''})
    const handleChangeFruitCanEat = e => {
        setBodyFruitCanEat({
          ...bodyFruitCanEat,
          [e.target.name]: e.target.value
      })
    }

    

    const  deleteItem = ( name, value) => {
        setBody({
            ...body,
            [name]: value
        })
    }

   
    const handleChangeDate = (newValue) => {
        setBody({
            ...body,
            ["assessmentDate"]: newValue
        })
    };//3202569000
    const addReferrals = (referral, plan, planKey) => {
         referral.id = uuid();
        
    
        if(plan?.length > 0 ){
            plan = plan.concat(referral);
          } else {
            plan = []
            plan.push(referral);
          }

          setBody({
            ...body,
            [planKey]: plan
        })
        setBodyNutricionistPlan({
            ...bodyNutricionistPlan,
            ["description"]: ''
        })
        setBodyFoodCanEat({
            ...bodyFoodCanEat,
            ["description"]: ''
        })
        setBodyFoodNotAllowedEat({
            ...bodyFoodNotAllowedEat,
            ["description"]: ''
        })
        setBodyFruitCanEat({
            ...bodyFruitCanEat,
            ["description"]: ''
        })
        
    }
  
    const columnsNutricionsPlan = [
        { field: 'description', headerName: 'Plan', editable: true, width: 450 },
        { field:'editar', headerName: 'Action', align: 'center', headerAlign: 'center',  sortable: false, renderCell: (params) => {
            return (
                <div>
                    <ListItemButton onClick={() => {
                        body.referrals = body.referrals.filter(referral => referral.id != params.row.id);
                        deleteItem("referrals", body.referrals);
                    }}>
                    <DeleteIcon />
                    </ListItemButton>
                </div>
            );
        } }
    ];
    const columnsReminderSummary = [
        { field: 'id', headerName: 'Codigo',  width: 20 },
        { field: 'day', headerName: 'Dia',  width: 100 },
        { field: 'option', headerName: 'Opcion', editable: true,  width: 180 }
    ];
    
    const columnsMealPlan = [
        { field: 'id', headerName: 'Codigo',  width: 20 },
        { field: 'day', headerName: 'Dia',  width: 100 },
        { field: 'desayuno', headerName: 'Desayuno', editable: true,  width: 180 },
        { field: 'mediaMa', headerName: 'Media Mañana', editable: true,  width: 180 },
        { field: 'almuerzo', headerName: 'Almuerzo', editable: true,  width: 180 },
        { field: 'mediaTa', headerName: 'Media Tarde', editable: true,  width: 180 },
        { field: 'cena', headerName: 'Cena', editable: true,  width: 180 }
    ];


    

    const [evolutionToCut, setPreviousEvolutions] = useState(props.affiliateInfo.evolutionsNutricionist);
    const previousEvolutions = evolutionToCut.filter(evolution => evolution.id != null);
    const [indexEvolution, setIndexEvolution] = useState(-1);
    const changeOfEvolutions = e => {
        const {value } = e.target;
        //console.log("value of evolutions es ____ " + value);
        setIndexEvolution(value);
        if(value == -1) {
            setBody(props.affiliateInfo.evolutionsNutricionist[props.indexEvolution]);
        } else {
            setBody(props.affiliateInfo.evolutionsNutricionist[value]);
        }
       
    }

    const [openLoader, setOpenLoader] = React.useState(false);

      const onSubmit = (props) => {
        if(indexEvolution != -1) {
            return;
        }
        
        props.affiliateInfo.evolutionsNutricionist[props.indexEvolution] = body;

     console.log("antes de guardar ^^= " + JSON.stringify(props.affiliateInfo));
        setOpenLoader(true);
        axios.post(url, props.affiliateInfo).then(response => { 
            setOpenLoader(false);
           // console.log("enviando " + JSON.stringify(props.affiliateInfo));
            props.setAffiliate(props.affiliateInfo);
            props.changeMenu(12);
          });
	 }
    return (
        <div>
        <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3 }}>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
                <Grid container spacing={1}  >

                    <Grid item xs={12} sm={6} md={4} >
                    <Box color='GrayText' fontSize={20} >
                            Nombre: {props.affiliateInfo.patient.firstName} {props.affiliateInfo.patient.secondName} {props.affiliateInfo.patient.lastName} {props.affiliateInfo.patient.secondLastName}
                    </Box>

                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20} >
                            Identificacion: {props.affiliateInfo.patient.id} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            Edad:  {(new Date()).getFullYear() - (new Date(props.affiliateInfo.patient.birthday)).getFullYear()} 
                         </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            Direccion:  {props.affiliateInfo.patient.address} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            Sexo:  {props.affiliateInfo.patient.gender} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDatePicker
                                id='assessmentDate'
                                name='assessmentDate'
                                label="Fecha Valoración de Paciente."
                                inputFormat="MM/dd/yyyy"
                                value={body.assessmentDate}
                                onChange={handleChangeDate}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                       
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                        <InputLabel id="evolutionsLabel">Evoluciones</InputLabel>
                        <Select
                            labelId="evolutionsLabel"
                            id="evolutions"
                            name="evolutions"
                            defaultValue={-1}
                            label="Evoluciones"
                            onChange={changeOfEvolutions}
                        >
                            <MenuItem value={-1}> Evolucionar  </MenuItem>
                            {previousEvolutions.map((ev,index)=>{
                                return <MenuItem value={index}> {ev.assessmentDate} </MenuItem>;
                                }
                            )}
                           
                        </Select>
                        </Box>
                    </Grid>


                </Grid>
            </Paper>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
              <Grid container spacing={1}  >
                <Grid item xs={12} sm={6} md={4}>
                <FormControl>
            <FormLabel id="bedRidden">POSTRADO EN CAMA</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="NO"
              name="bedRidden"
              onChange={handleChange}>
              <FormControlLabel value="SI" defaultChecked={body.bedRidden} control={<Radio />} label="Si" />
              <FormControlLabel value="NO" defaultChecked={!body.bedRidden} control={<Radio />} label="No" />
              
            </RadioGroup>
          </FormControl>
                </Grid>
        
                <Grid item xs={12} sm={6} md={4}>
          <FormControl>
            <FormLabel id="bedRidden">Edema</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="NO"
              name="edema"
              onChange={handleChange}>
              <FormControlLabel value="SI" defaultChecked={body.edema} control={<Radio />} label="Si" />
              <FormControlLabel value="NO" defaultChecked={!body.edema} control={<Radio />} label="No" />
              
            </RadioGroup>
          </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                        
                            <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Ojos</Typography>
                            <TextField
                                id='eyeExam'
                                name='eyeExam'
                                value={body.eyeExam}
                                onChange={handleChange}
                                disabled={indexEvolution != -1}
                                variant='outlined'
                                aria-label="minimum height"
                                multiline
                                minRows={1}
                                placeholder="Ojos"
                                fullWidth />
                       
                </Grid>
                
                <Grid item xs={12} sm={6} md={4}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Cabello</Typography>
                        <TextField
                            id='hairExam'
                            name='hairExam'
                            value={body.hairExam}
                            onChange={handleChange}
                            disabled={indexEvolution != -1}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            placeholder="Cabello"
                            fullWidth />
                   
                </Grid>
                
                <Grid item xs={12} sm={6} md={4}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Piel</Typography>
                        <TextField
                            id='skinExam'
                            name='skinExam'
                            value={body.skinExam}
                            onChange={handleChange}
                            disabled={indexEvolution != -1}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            placeholder="Piel"
                            fullWidth />
                   
                </Grid>
             </Grid> 
            </Paper>
             <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
             <Grid container spacing={1}  >
                <Grid item xs={12} sm={6} md={4}>
                        
                            <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Peso</Typography>
                            <TextField
                                id='weight'
                                name='weight'
                                value={body.weight}
                                onChange={handleChange}
                                disabled={indexEvolution != -1}
                                variant='outlined'
                                aria-label="minimum height"
                                multiline
                                minRows={1}
                                placeholder="Peso KG"
                                fullWidth />
                       
                </Grid>
                
                <Grid item xs={12} sm={6} md={4}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Talla</Typography>
                        <TextField
                            id='height'
                            name='height'
                            value={body.height}
                            onChange={handleChange}
                            disabled={indexEvolution != -1}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            placeholder="Talla "
                            fullWidth />
                   
                </Grid>
                
                <Grid item xs={12} sm={6} md={4}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>IMC</Typography>
                        <TextField
                            id='imc'
                            name='imc'
                            value={body.imc}
                            onChange={handleChange}
                            disabled={indexEvolution != -1}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            placeholder="IMC"
                            fullWidth />
                   
                </Grid>
             </Grid>
            </Paper>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            <Grid container spacing={1}  >
                <Grid item xs={12} sm={6} md={4}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>DIAGNOSTICO NUTRICIONAL</Typography>
                        <TextField
                            id='mainDiagnosis'
                            name='mainDiagnosis'
                            value={body.mainDiagnosis}
                            onChange={handleChange}
                            disabled={indexEvolution != -1}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            placeholder="DIAGNOSTICO NUTRICIONAL"
                            fullWidth />
                   
                </Grid>
                
                <Grid item xs={12} sm={6} md={4}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>OBSERVACION</Typography>
                        <TextField
                            id='descriptionDiagnosis'
                            name='descriptionDiagnosis'
                            value={body.descriptionDiagnosis}
                            onChange={handleChange}
                            disabled={indexEvolution != -1}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            placeholder="OBSERVACION"
                            fullWidth />
                   
                </Grid>
            </Grid>
            </Paper>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            <Grid container spacing={1}  >
           
                <Grid item  xs={12} sm={6} md={4} className="header">
                            <div>
                            <InputLabel id="typeLabel">LACTEOS</InputLabel>
                                <Select
                                    labelId="typeLabel"
                                    id="type"
                                    name="LACTEOS"
                                    value={body.frequencyFoodConsumption['LACTEOS']}
                                    onChange={handleChangeListado}
                                    label="Frecuencia de Consumo"
                                >
                                    <MenuItem value={"0"}>
                                        <em>Frecuencia de Consumo</em>
                                    </MenuItem>
                                    <MenuItem value={"DIARIO"}>1. DIARIO</MenuItem>
                                    <MenuItem value={"SEMANAL"}>2. SEMANAL</MenuItem>
                                    <MenuItem value={"QUINCENAL"}>3. QUINCENAL</MenuItem>
                                    <MenuItem value={"MENSUAL"}>4. MENSUAL</MenuItem>
                                    <MenuItem value={"OCACIONAL"}>5. OCACIONAL</MenuItem>
                                    <MenuItem value={"NUNCA"}>6. NUNCA</MenuItem>
                                    </Select>
                            </div>
                       
                </Grid>
                
                <Grid item  xs={12} sm={6} md={4} className="header">
                            <div>
                            <InputLabel id="typeLabel">CEREALES</InputLabel>
                                <Select
                                    labelId="typeLabel"
                                    id="type"
                                    name="CEREALES"
                                    value={body.frequencyFoodConsumption['CEREALES']}
                                    onChange={handleChangeListado}
                                    label="Frecuencia de Consumo"
                                >
                                    <MenuItem value={"0"}>
                                        <em>Frecuencia de Consumo</em>
                                    </MenuItem>
                                    <MenuItem value={"DIARIO"}>1. DIARIO</MenuItem>
                                    <MenuItem value={"SEMANAL"}>2. SEMANAL</MenuItem>
                                    <MenuItem value={"QUINCENAL"}>3. QUINCENAL</MenuItem>
                                    <MenuItem value={"MENSUAL"}>4. MENSUAL</MenuItem>
                                    <MenuItem value={"OCACIONAL"}>5. OCACIONAL</MenuItem>
                                    <MenuItem value={"NUNCA"}>6. NUNCA</MenuItem>
                                    </Select>
                            </div>
                       
                </Grid>
                
                <Grid item  xs={12} sm={6} md={4} className="header">
                            <div>
                            <InputLabel id="typeLabel">CARNES</InputLabel>
                                <Select
                                    labelId="typeLabel"
                                    id="type"
                                    name="CARNES"
                                    value={body.frequencyFoodConsumption['CARNES']}
                                    onChange={handleChangeListado}
                                    label="Frecuencia de Consumo"
                                >
                                    <MenuItem value={"0"}>
                                        <em>Frecuencia de Consumo</em>
                                    </MenuItem>
                                    <MenuItem value={"DIARIO"}>1. DIARIO</MenuItem>
                                    <MenuItem value={"SEMANAL"}>2. SEMANAL</MenuItem>
                                    <MenuItem value={"QUINCENAL"}>3. QUINCENAL</MenuItem>
                                    <MenuItem value={"MENSUAL"}>4. MENSUAL</MenuItem>
                                    <MenuItem value={"OCACIONAL"}>5. OCACIONAL</MenuItem>
                                    <MenuItem value={"NUNCA"}>6. NUNCA</MenuItem>
                                    </Select>
                            </div>
                       
                </Grid>
                
                <Grid item xs={12} sm={6} md={4} className="header">
                            <div>
                            <InputLabel id="typeLabel">FRUTAS</InputLabel>
                                <Select
                                    labelId="typeLabel"
                                    id="type"
                                    name="FRUTAS"
                                    value={body.frequencyFoodConsumption['FRUTAS']}
                                    onChange={handleChangeListado}
                                    label="Frecuencia de Consumo"
                                >
                                    <MenuItem value={"0"}>
                                        <em>Frecuencia de Consumo</em>
                                    </MenuItem>
                                    <MenuItem value={"DIARIO"}>1. DIARIO</MenuItem>
                                    <MenuItem value={"SEMANAL"}>2. SEMANAL</MenuItem>
                                    <MenuItem value={"QUINCENAL"}>3. QUINCENAL</MenuItem>
                                    <MenuItem value={"MENSUAL"}>4. MENSUAL</MenuItem>
                                    <MenuItem value={"OCACIONAL"}>5. OCACIONAL</MenuItem>
                                    <MenuItem value={"NUNCA"}>6. NUNCA</MenuItem>
                                    </Select>
                            </div>
                       
                </Grid>
                 
                <Grid item xs={12} sm={6} md={4} className="header">
                            <div>
                            <InputLabel id="typeLabel">VERDURAS</InputLabel>
                                <Select
                                    labelId="typeLabel"
                                    id="type"
                                    name="VERDURAS"
                                    value={body.frequencyFoodConsumption['VERDURAS']}
                                    onChange={handleChangeListado}
                                    label="Frecuencia de Consumo"
                                >
                                    <MenuItem value={"0"}>
                                        <em>Frecuencia de Consumo</em>
                                    </MenuItem>
                                    <MenuItem value={"DIARIO"}>1. DIARIO</MenuItem>
                                    <MenuItem value={"SEMANAL"}>2. SEMANAL</MenuItem>
                                    <MenuItem value={"QUINCENAL"}>3. QUINCENAL</MenuItem>
                                    <MenuItem value={"MENSUAL"}>4. MENSUAL</MenuItem>
                                    <MenuItem value={"OCACIONAL"}>5. OCACIONAL</MenuItem>
                                    <MenuItem value={"NUNCA"}>6. NUNCA</MenuItem>
                                    </Select>
                            </div>
                       
                </Grid>
                    
                <Grid item xs={12} sm={6} md={4} className="header">
                            <div>
                            <InputLabel id="typeLabel">LEGUMINOSAS</InputLabel>
                                <Select
                                    labelId="typeLabel"
                                    id="type"
                                    name="LEGUMINOSAS"
                                    value={body.frequencyFoodConsumption['LEGUMINOSAS']}
                                    onChange={handleChangeListado}
                                    label="Frecuencia de Consumo"
                                >
                                    <MenuItem value={"0"}>
                                        <em>Frecuencia de Consumo</em>
                                    </MenuItem>
                                    <MenuItem value={"DIARIO"}>1. DIARIO</MenuItem>
                                    <MenuItem value={"SEMANAL"}>2. SEMANAL</MenuItem>
                                    <MenuItem value={"QUINCENAL"}>3. QUINCENAL</MenuItem>
                                    <MenuItem value={"MENSUAL"}>4. MENSUAL</MenuItem>
                                    <MenuItem value={"OCACIONAL"}>5. OCACIONAL</MenuItem>
                                    <MenuItem value={"NUNCA"}>6. NUNCA</MenuItem>
                                    </Select>
                            </div>
                       
                </Grid>
                    
                <Grid item xs={12} sm={6} md={4} className="header">
                            <div>
                            <InputLabel id="typeLabel">GRASAS</InputLabel>
                                <Select
                                    labelId="typeLabel"
                                    id="type"
                                    name="GRASAS"
                                    value={body.frequencyFoodConsumption['GRASAS']}
                                    onChange={handleChangeListado}
                                    label="Frecuencia de Consumo"
                                >
                                    <MenuItem value={"0"}>
                                        <em>Frecuencia de Consumo</em>
                                    </MenuItem>
                                    <MenuItem value={"DIARIO"}>1. DIARIO</MenuItem>
                                    <MenuItem value={"SEMANAL"}>2. SEMANAL</MenuItem>
                                    <MenuItem value={"QUINCENAL"}>3. QUINCENAL</MenuItem>
                                    <MenuItem value={"MENSUAL"}>4. MENSUAL</MenuItem>
                                    <MenuItem value={"OCACIONAL"}>5. OCACIONAL</MenuItem>
                                    <MenuItem value={"NUNCA"}>6. NUNCA</MenuItem>
                                    </Select>
                            </div>
                       
                </Grid>
                
                <Grid item xs={12} sm={6} md={4} className="header">
                            <div>
                            <InputLabel id="typeLabel">AZUCARES</InputLabel>
                                <Select
                                    labelId="typeLabel"
                                    id="type"
                                    name="AZUCARES"
                                    value={body.frequencyFoodConsumption['AZUCARES']}
                                    onChange={handleChangeListado}
                                    label="Frecuencia de Consumo"
                                >
                                    <MenuItem value={"0"}>
                                        <em>Frecuencia de Consumo</em>
                                    </MenuItem>
                                    <MenuItem value={"DIARIO"}>1. DIARIO</MenuItem>
                                    <MenuItem value={"SEMANAL"}>2. SEMANAL</MenuItem>
                                    <MenuItem value={"QUINCENAL"}>3. QUINCENAL</MenuItem>
                                    <MenuItem value={"MENSUAL"}>4. MENSUAL</MenuItem>
                                    <MenuItem value={"OCACIONAL"}>5. OCACIONAL</MenuItem>
                                    <MenuItem value={"NUNCA"}>6. NUNCA</MenuItem>
                                    </Select>
                            </div>
                       
                </Grid>
            </Grid>
            </Paper>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            <Grid container spacing={1}  >
                <Grid item  xs={12} sm={6} md={4} className="header">
                            <div>
                            <InputLabel id="typeApetitoLabel">APETITO</InputLabel>
                                <Select
                                    labelId="typeApetitoLabel"
                                    id="apetito"
                                    name="apetito"
                                    value={body.apetito}
                                    onChange={handleChange}
                                    label="apetito"
                                >
                                    <MenuItem value={"0"}>
                                        <em>ESTADO</em>
                                    </MenuItem>
                                    <MenuItem value={"BUENO"}>1. BUENO</MenuItem>
                                    <MenuItem value={"MALO"}>2. MALO</MenuItem>
                                    <MenuItem value={"REGULAR"}>3. REGULAR</MenuItem>
                                   
                                    </Select>
                            </div>
                       
                </Grid>
                
                <Grid item  xs={12} sm={6} md={4} className="header">
                <FormControl>
            <FormLabel id="allergic">ES ALERGICO O INTOLERANTE A ALGUN ALIMENTO</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="NO"
              name="allergic"
              onChange={handleChange}>
              <FormControlLabel value="SI" defaultChecked={body.allergic} control={<Radio />} label="Si" />
              <FormControlLabel value="NO" defaultChecked={!body.allergic} control={<Radio />} label="No" />
              
            </RadioGroup>
          </FormControl>
                </Grid>
          
                <Grid item xs={12} sm={6} md={4}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>CUAL?</Typography>
                        <TextField
                            id='descriptionAllergic'
                            name='descriptionAllergic'
                            value={body.descriptionAllergic}
                            onChange={handleChange}
                            disabled={indexEvolution != -1}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            placeholder="Descripcion de la alergia"
                            fullWidth />
                   
                </Grid>

             </Grid>
            </Paper>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            <Grid container spacing={1}  >

                <Grid item  xs={12} sm={6} md={4} className="header">
                <FormControl>
            <FormLabel id="allergicFamily">ALERGIAS FAMILIARES</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="NO"
              name="allergicFamily"
              onChange={handleChange}>
              <FormControlLabel value="SI" defaultChecked={body.allergicFamily} control={<Radio />} label="Si" />
              <FormControlLabel value="NO" defaultChecked={!body.allergicFamily} control={<Radio />} label="No" />
              
            </RadioGroup>
          </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>EXPLICAR</Typography>
                        <TextField
                            id='descriptionAllergicFamily'
                            name='descriptionAllergicFamily'
                            value={body.descriptionAllergicFamily}
                            onChange={handleChange}
                            disabled={indexEvolution != -1}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            placeholder="Alergia Familiar"
                            fullWidth />
                   
                </Grid>
                
            </Grid>
            </Paper>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            <Grid container spacing={1}  >
                <Grid item xs={6} sm={6} md={6} className="header">
                    <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            
            <Box>
                <form>
                <Grid container spacing={2} > 
                  
                    <Grid item xs={12}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>PLAN NUTRICIONAL:</Typography>
                        <TextField
                            id='description'
                            name='description'
                            value={bodyNutricionistPlan.description}
                            onChange={handleChangeNutricionistPlan}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            fullWidth
                           />
                   
                    </Grid>
                    
        

                
                    <Grid item xs={12} >
                
                      <Button 
                     // type="submit" 
                      variant="contained" 
                      color="primary" 
                      display="inline" 
                      //onClick={() => buttonSave(props)}
                      onClick={() => addReferrals(bodyNutricionistPlan, body.nutricionistPlan, "nutricionistPlan")}
                      >
                          Agregar Plan nutricional
                      </Button>
                  </Grid>

                    </Grid>
                 </form>
        </Box>
            {(body.nutricionistPlan.length > 0) ?
         
           <DataGrid
                rows={body.nutricionistPlan}
                columns={columnsNutricionsPlan}
                pagination
                checkboxSelection={true}
                autoHeight= {true} 
                
                />: '' }
           
        
                </Paper>
                </Grid>
                <Grid item xs={6} sm={6} md={6} className="header">
                    <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            
            <Box>
                <form>
                <Grid container spacing={2} > 
                  
                    <Grid item xs={12}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>ALIMENTOS QUE DEBE CONSUMIR:</Typography>
                        <TextField
                            id='description'
                            name='description'
                            value={bodyFoodCanEat.description}
                            onChange={handleChangeFoodCanEat}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            fullWidth
                           />
                   
                    </Grid>
                    
        

                
                    <Grid item xs={12} >
                
                      <Button 
                     // type="submit" 
                      variant="contained" 
                      color="primary" 
                      display="inline" 
                      //onClick={() => buttonSave(props)}
                      onClick={() => addReferrals(bodyFoodCanEat, body.foodCanEat, "foodCanEat")}
                      >
                          Agregar 
                      </Button>
                  </Grid>

                    </Grid>
                 </form>
        </Box>
            {(body.foodCanEat?.length > 0) ?
         
           <DataGrid
                rows={body.foodCanEat}
                columns={columnsNutricionsPlan}
                pagination
                checkboxSelection={true}
                autoHeight= {true} 
                
                />: '' }
           
        
                </Paper>
                </Grid>

                <Grid item xs={6} sm={6} md={6} className="header">
                    <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            
            <Box>
                <form>
                <Grid container spacing={2} > 
                  
                    <Grid item xs={12}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>ALIMENTOS QUE DEBE EVITAR:</Typography>
                        <TextField
                            id='description'
                            name='description'
                            value={bodyFoodNotAllowedEat.description}
                            onChange={handleChangeFoodNotAllowedEat}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            fullWidth
                           />
                   
                    </Grid>
                    
        

                
                    <Grid item xs={12} >
                
                      <Button 
                     // type="submit" 
                      variant="contained" 
                      color="primary" 
                      display="inline" 
                      //onClick={() => buttonSave(props)}
                      onClick={() => addReferrals(bodyFoodNotAllowedEat, body.foodNotAllowedEat, "foodNotAllowedEat")}
                      >
                          Agregar
                      </Button>
                  </Grid>

                    </Grid>
                 </form>
        </Box>
            {(body.foodNotAllowedEat?.length > 0) ?
         
           <DataGrid
                rows={body.foodNotAllowedEat}
                columns={columnsNutricionsPlan}
                pagination
                checkboxSelection={true}
                autoHeight= {true} 
                
                />: '' }
           
        
                </Paper>
                </Grid>

            <Grid item xs={6} sm={6} md={6} className="header">
                    <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            
            <Box>
                <form>
                <Grid container spacing={2} > 
                  
                    <Grid item xs={12}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>FRUTAS QUE PUEDE CONSUMIR POR SU BAJO INDICE GLUCEMICO:</Typography>
                        <TextField
                            id='description'
                            name='description'
                            value={bodyFruitCanEat.description}
                            onChange={handleChangeFruitCanEat}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            fullWidth
                           />
                   
                    </Grid>
                    
        

                
                    <Grid item xs={12} >
                
                      <Button 
                     // type="submit" 
                      variant="contained" 
                      color="primary" 
                      display="inline" 
                      //onClick={() => buttonSave(props)}
                      onClick={() => addReferrals(bodyFruitCanEat, body.fruitCanEat, "fruitCanEat")}
                      >
                          Agregar 
                      </Button>
                  </Grid>

                    </Grid>
                 </form>
        </Box>
            {(body.fruitCanEat?.length > 0) ?
         
           <DataGrid
                rows={body.fruitCanEat}
                columns={columnsNutricionsPlan}
                pagination
                checkboxSelection={true}
                autoHeight= {true} 
                
                />: '' }
           
        
                </Paper>
                </Grid>
           </Grid>

           <Grid item xs={6} sm={6} md={6}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>CONCLUSION</Typography>
                        <TextField
                            id='conclusion'
                            name='conclusion'
                            value={body.conclusion}
                            onChange={handleChange}
                            disabled={indexEvolution != -1}
                            variant='outlined'
                            aria-label="minimum height"
                            multiline
                            minRows={1}
                            placeholder="CONCLUSION"
                            fullWidth />
                   
                </Grid>
           </Paper>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            <Grid item xs={12} sm={12} md={12} className="header">
          <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
             
            {(body.reminderSummary.length > 0) ?
         
           <DataGrid
                getRowId={(row) => row.id} 
                rows={body.reminderSummary}
                columns={columnsReminderSummary}
                processRowUpdate={processRowUpdate}
                onProcessRowUpdateError={() =>
                    console.log("ereror  asdf")
                }
                autoHeight= {true} 
                
                />: '' }
           
        
          </Paper>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="header">
          <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
             
            {(body.mealPlan.length > 0) ?
         
           <DataGrid
                rows={body.mealPlan}
                columns={columnsMealPlan}
                processRowUpdate={processRowUpdate}
                autoHeight= {true} 
                
                />: '' }
           
        
          </Paper>
                </Grid>
          
                <Grid item xs={12} sm={12} md={12}>
                      
                            <Button 
                           // type="submit" 
                            variant="contained" 
                            color="primary" 
                            display="inline" 
                            //onClick={() => buttonSave(props)}
                            onClick={() => {
                                if (indexEvolution != -1) {
                                    props.setIndexEvolution(indexEvolution);
                                    props.setAffiliate(props.affiliateInfo);
                                    props.changeMenu(12)
                                } else {
                                    
                                    onSubmit(props);
                                }
                            }}>
                                Cerrar Historia
                            </Button>
                </Grid>
             
            </Paper>
        </Box>

<Backdrop
sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
open={openLoader}>
<CircularProgress color="inherit" />
</Backdrop>
</div>
    );
}